import React from "react";
import "./navbar.css";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Container from "react-bootstrap/Container";
import { Link } from "react-router-dom";

function Navbarrr() {
  return (
    <div>
      <Navbar collapseOnSelect expand="lg" bg="transparent" variant="light">
        <Container>
          <Link to="/">
            <img className="nlsalogo" src="images/nlsa.png" alt="nlsalogo" />
          </Link>

          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link>
                <Link to="/" className="txtttt">
                  Home
                </Link>
              </Nav.Link>

              <Nav.Link>
                {" "}
                <Link to="/lims" className="txtttt">
                  Lims
                </Link>
              </Nav.Link>

              <Nav.Link>
                {" "}
                <Link to="/shortcourses" className="txtttt">
                  Short Courses
                </Link>
              </Nav.Link>
              <NavDropdown
                className="txtttt"
                title="Nlsa Society"
                id="collasible-nav-dropdown"
              >
                <NavDropdown.Item>
                  <Link to="/tours">Tours</Link>
                </NavDropdown.Item>
                <NavDropdown.Item>
                  {" "}
                  <Link to="/events">Events</Link>
                </NavDropdown.Item>
              </NavDropdown>
              <Nav.Link>
                {" "}
                <Link to="/contactus" className="txtttt">
                  Contact Us
                </Link>
              </Nav.Link>
            </Nav>
            <Nav>
              <Nav.Link
                href="https://www.facebook.com/NLSA112"
                className="txtttt"
              >
                <img className="fbbb" alt="abc" src="fb.png"></img>
              </Nav.Link>
              <Nav.Link
                href="https://www.youtube.com/@newlahorescienceacademy3229"
                className="txtttt"
              >
                <img className="fbbb" alt="abc" src="youtube.png"></img>
              </Nav.Link>
              <Nav.Link href="https://wa.me/03084042712" className="txtttt">
                <img className="fbbb" alt="abc" src="whatsapp.png"></img>
              </Nav.Link>
              <Nav.Link href="#Twitter" className="txtttt">
                <img className="fbbb" alt="abc" src="twitter.png"></img>
              </Nav.Link>{" "}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}

export default Navbarrr;
